import {makeStyles} from "@material-ui/core";

export const useServiziDetailsFilterStyles = makeStyles(() => ({
    radioButtons: {
        margin: "0.3em 1em",
    }
}));